module.exports = __webpack_public_path__ + "static/media/shareBg2.ad40ffff.png";